import React, {Component} from 'react';
import PropTypes from 'prop-types';

import '../../sass/form/item-select.scss';

export default class ItemSelect extends Component
{
    constructor(props) {
        super(props);

        this.selectItem = this.selectItem.bind(this);
        this.state = {item: "0"}
    }

    selectItem(item) {
        this.setState({item: item});
    }

    render() {
        let items = Object.entries(this.props.items);
        

        
        return (
            <div className="forms-select forms-item-select">
                <div>
                {
                    items.map( ([k, item]) => {
                        let key = item.key;
                        let cssClass = "item";
                        if (key == this.state.item) cssClass += " selected";
                        return (<div className={cssClass} key={key} onClick={(e) => this.selectItem(key)} >
                            {item}
                        </div>)
                        }
                    )
                }  
                </div>
                <select readOnly={true} name={this.props.name} value={this.state.item} hidden={true}>
                    <option value="0"></option>
                    { items.map( ([k, item]) => <option key={item.key} value={item.key}>{item.key}</option>) }
                </select>
                <div style={{ clear: "both"}}/>
            </div>
        )
    }
}

ItemSelect.propTypes = {
    name: PropTypes.string.isRequired,
    items: PropTypes.array.isRequired,
    multiple: PropTypes.bool,
    defaultValue: PropTypes.any,
    onChange: PropTypes.func
}



// WEBPACK FOOTER //
// ./src/components/form/ItemSelect.js